import StateType from './state.type';

export default {
  loading: false,
  presignedUrl: '',
} as StateType;
